import React, { createContext, useContext, useState } from 'react';

const OwnershipContext = createContext();

export const OwnershipProvider = ({ children }) => {
  const [ownershipSelected, setOwnershipSelected] = useState(null);

  return (
    <OwnershipContext.Provider value={{ ownershipSelected, setOwnershipSelected }}>
      {children}
    </OwnershipContext.Provider>
  );
};

export const useOwnership = () => useContext(OwnershipContext);
